import React, { useContext, useEffect, useRef } from "react";
import styles from "./SliderBtn.module.scss";
const SliderBtn = (props) => {
  const { text, color, size, align } = props;
  let wrapClass = `${styles.wrap}`;
  let svgIcon = <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.75 17L7.625 8.875L0.750003 0.749998" stroke="#008359" strokeWidth="1.5" />
  </svg>;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  if (align !== undefined && styles[`wrap_${align}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${align}`]}`;
  }
  if (size !== undefined && styles[`wrap_${size}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${size}`]}`;
    if (size === 'big') {
      svgIcon = <svg width="13" height="28" viewBox="0 0 13 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 27L12 14L1 0.999998" stroke="#008359" strokeWidth="1.5" />
      </svg>;
    }
  }
  return (
    <>
      <div className={wrapClass}>
        <div className={styles.icon}>
          {svgIcon}
        </div>
        <div className={styles.text}>{text}</div>
      </div>
    </>
  );

}

export default SliderBtn;
